module.exports = __webpack_public_path__ + "static/SFCompactBlack-77e75a8d600bd1e1bbc4373592d0c9b3.woff2";